import React from "react";
import { Formik, Form, useField, useFormikContext } from "formik";
import MaskedInput from "react-text-mask";
import * as Yup from "yup";
import FieldFeedback, { useFieldFeedback } from "./ActiveAdmin/FieldFeedback";

import { identifySales } from "./api";

const IdentificationInput = ({ name, label, mask, type = "text", placeholder }) => {
  const [field, meta] = useField({ name, type });
  const error = meta.touched ? meta.error : undefined;
  const feedback = useFieldFeedback({}, error);
  return (
    <div data-signal-field="" data-signal-label={label} data-signal-name={name}>
      <label htmlFor={feedback.id}>{label}</label>
      {mask ? (
        <MaskedInput {...field} {...feedback} placeholder={placeholder} mask={mask} />
      ) : (
        <input {...field} {...feedback} type={type} placeholder={placeholder} />
      )}
      <FieldFeedback id={feedback.id} error={error} />
    </div>
  );
};

const IdentificationForm = ({ children }) => {
  const { errors, touched } = useFormikContext();
  const visibleErrors = Object.keys(errors).reduce((result, name) => {
    if (touched[name]) result[name] = errors[name];
    return result;
  }, {});
  return <Form data-signal-errors={JSON.stringify(visibleErrors)}>{children}</Form>;
};

const SalesIdForm = ({ idMethod }) => {
  const onSubmit = (values, { setSubmitting }) => {
    setSubmitting(true);
    identifySales(values)
      .then(
        (response) => window.location.replace(response.data.redirectTo),
        (error) => console.log(error),
      )
      .finally(() => setSubmitting(false));
  };

  const SNILS_REGEXP = /\d{3}-\d{3}-\d{3} \d{2}/;
  const SNILS_MASK = [/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, ' ', /\d/, /\d/];
  const PHONE_REGEXP = /\+7 \(\d{3}\) \d{3}-\d{2}-\d{2}/;
  const PHONE_MASK = ['+', '7', ' ', '(',  /\d/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/];

  const validationSchemaSnils = Yup.object({
    snils: Yup.string().required("Обязателен для заполнения").matches(SNILS_REGEXP, {message: "Неверный формат"}),
  });

  const validationSchemaPhone = Yup.object({
    phone: Yup.string().required("Обязателен для заполнения").matches(PHONE_REGEXP, {message: "Неверный формат"}),
  });

  const validationSchemaEmail = Yup.object({
    email: Yup.string().required("Обязателен для заполнения").email("Неверный формат email"),
  });


  return (
    <div className="sales_id_form">
      {(() => {
        if (idMethod == "snils") {
          return (
          <div>
            <h1>Укажите свой СНИЛС</h1>
            <Formik initialValues={{snils: ""}} validationSchema={validationSchemaSnils} onSubmit={onSubmit} >
              <IdentificationForm>
                <IdentificationInput name="snils" label="СНИЛС" placeholder="999-999-999 99" mask={SNILS_MASK} />
                <button type="submit">Применить</button>
              </IdentificationForm>
            </Formik>
          </div>
          )
        } else if (idMethod == "email") {
          return (
          <div>
            <h1>Укажите свой email</h1>
            <Formik initialValues={{email: ""}} validationSchema={validationSchemaEmail} onSubmit={onSubmit} >
              <IdentificationForm>
                <IdentificationInput name="email" label="Email" type="email" placeholder="example@mail.ru" />
                <button type="submit">Применить</button>
              </IdentificationForm>
            </Formik>
          </div>
          )
        } else {
          return (
          <div>
            <h1>Укажите свой номер телефона</h1>
            <Formik initialValues={{phone: ""}} validationSchema={validationSchemaPhone} onSubmit={onSubmit} >
              <IdentificationForm>
                <IdentificationInput name="phone" label="Номер телефона" placeholder="+7 (999) 999-99-99" mask={PHONE_MASK} />
                <button type="submit">Применить</button>
              </IdentificationForm>
            </Formik>
          </div>
          )
        }
      })()}
    </div>
  );
};

export default SalesIdForm;
